export default {
  header: {
    home: 'ホーム',
    about: '会社概要',
    technology: '技術紹介',
    products: '製品紹介',
    services: 'サービス',
    contacts: 'お問い合わせ',
    oem: '受託製造',
    rawMaterial: '原材料カスタマイズ',
    productCustomization: '製品カスタマイズ',
    importExport: '輸出入'
  },
  gmi: {
    title: '芝美安® SK Premium Gel',
    subtitle: '芝美安® SKプレミアムジェル（SK Premium Gel）は、毎日のスキンケアに取り入れやすい、日本製のジェルタイプ化粧品です。',
    body1: 'みずみずしく軽やかなジェルが肌になじみ、乾燥しやすい肌や外的刺激が気になる肌をやさしく整えます。',
    body2: 'アルコール・香料不使用のやさしい処方で、デリケートな肌の日々のお手入れにもお使いいただけます。',
    heroNote: '本品は外用化粧品です。医薬品ではなく、診断・治療・予防を目的とするものではありません。',
    aboutTitle: 'About GMI',
    aboutText: 'Ganoderma Microsporum Immunomodulatory Protein（GMI）は、台湾由来の希少なGanoderma microsporumに由来する注目成分です。異種タンパク質発現技術と液体発酵技術を用いて開発され、次世代のGanoderma由来成分として期待されています。',
    aboutList1: '30年以上にわたる研究実績',
    aboutList2: '41報以上の科学・医療分野における発表論文',
    aboutList3: '43件の国際特許を取得（中国、台湾、米国、EU、日本）',
    aboutList4: '米国のNew Dietary Ingredient（NDI）',
    aboutList5: '化粧品成分としてINCIおよびJP-INCIに収載',
    featuresTitle: 'Product Features',
    featuresCard1Title: '注目成分',
    featuresCard1Item1: '次世代のGanoderma由来成分',
    featuresCard1Item2: 'GMIを配合した独自着目成分',
    featuresCard1Item3: '先進的なバイオアクティブ成分',
    featuresCard2Title: 'こだわりの処方',
    featuresCard2Item1: 'みずみずしく軽やかなウォーターベースのジェルテクスチャー',
    featuresCard2Item2: 'アルコール・香料不使用のやさしい処方',
    featuresCard2Item3: '肌テスト済みのやさしい使い心地',
    featuresCard2Item4: '持ち運びしやすいコンパクトなチューブタイプ',
    detailsTitle: '製品詳細',
    details: {
      ingredientsTitle: '配合成分（主な整肌成分）',
      ingredientsText1: 'グリチルリチン酸2K',
      ingredientsText2: 'GMI（ピチア遺伝子組換ガノデルマミクロスポルムポリペプチド－１培養液エキス）',
      ingredientsText3: '',
      ingredientsText4: '',
      specification: '内容量',
      specificationText1: '10mL',
      specificationText2: '',
      specificationText3: '',
      recommendedUse: 'ご使用方法',
      recommendedUseText1: '適量を手に取り、乾燥が気になる部分になじませてください。必要に応じて、ご使用してください。',
      recommendedUseText2: '1日1～3回を目安にご使用ください。',
      recommendedUseText3: 'おすすめのご使用シーン',
      recommendedUseText4: '肌を整える毎日のケアに',
      recommendedUseText5: '乾燥や外的刺激が気になるときに',
      recommendedUseText6: 'デリケートな肌のケアに',
      recommendedUseText7: '特別なお手入れ後の肌のケアに',
      shelfLife: '使用期限',
      shelfLifeText1: '36か月',
      shelfLifeText2: '',
      shelfLifeText3: '',
      cautionTitle: 'ご使用上の注意',
      cautionText1: 'お肌に異常が生じていないかよく注意して使用してください。',
      cautionText2: '化粧品がお肌に合わないとき即ち次のような場合には、使用を中止してください。',
      cautionText3: 'そのまま化粧品の使用を続けますと、症状を悪化させることがありますので、皮膚科専門医等にご相談されることをおすすめします。'
    },
    distributionTitle: '販売・購入',
    officialStore: '誠科医薬公式ストア',
    addressLine: '住所：〒531-0073 大阪府大阪市東住吉区杭全1-17-17 3F',
    contactLabel: 'お問い合わせ：'
  },
  home: {
    coreBusiness: '事業内容',
    platform: '新規ドラッグデリバリープラットフォーム',
    oneStopPlatform: 'ワンストップ産業チェーンサービスプラットフォーム',
    formulation: '革新的な製剤技術',
    dosageForm: '剤形',
    dosageForms: {
      oralFilms: '口腔内崩壊フィルム',
      transdermal: '経皮吸収パッチ',
      granule: '口腔内崩壊顆粒'
    },
    application: '用途',
    applicationText: '小児／高齢者／嚥下が困難な方／ペット など',
    productStrategy: '製品戦略デザイン',
    productInfo: '製品情報データベース \nプロジェクト立ち上げ支援',
    productRegistration: '製品登録サービス',
    salesMarket: '販売・市場開発',
    supplyDistribution: '原材料供給・製品流通・カスタマイズ対応'
  },
  about: {
    companyProfile: '会社概要',
    location: '株式会社誠科医薬，本社：大阪府大阪市',
    businessScopes: '事業内容:',
    scope1: '製剤技術・新規剤形の開発',
    scope2: '海外規制対応（FDA）支援',
    scope3: '化粧品・健康食品・医薬品・添加物の海外展開支援',
    scope4: 'ペット関連製品（フード／用品／飼料添加物等）の卸売・小売',
    missionVision: '企業理念（Mission / Vision）'
  },
  footer: {
    exploration: '「今日の探求、',
    innovation: '未来の革新。」',
    pioneering: '開拓',
    exploring: '探求',
    innovating: '革新',
    surpassing: '超越',
    subscribeNow: '今すぐ登録',
    subscribe: '登録',
    contacts: 'お問い合わせ',
    email: 'メール：',
    copyright: 'Seikaiyaku.com | プライバシーポリシー© 2025 株式会社誠科医薬. All Rights Reserved.',
    copyrightMb: 'Copyright©2018-2025 Seikaiyaku.com All Rights Reserved.'
  },
  technology: {
    ddsTitle: 'DDS技術と応用領域',
    oralFilms: '口腔内崩壊フィルム',
    oralGranules: '口腔内崩壊顆粒',
    transdermalPatches: '経皮吸収型パッチ（貼付剤）',
    technicalSupport: '技術サポート',
    productDesign: '製品設計から技術支援まで、',
    comprehensiveSolutions: 'ワンストップでサポートします。',
    innovativePractice: '技術の活用シーン',
    effectiveFormula: '医薬品／動物用医薬品／ペット栄養／サプリメント等に対応。',
    petNutrition: '',
    enhancingConvenience: '使いやすさに配慮した剤形設計をサポートします。',
  },
  contacts: {
    title: 'お問い合わせ｜誠科医薬',
    contactsUs: 'お問い合わせ',
    registeredOffice: 'オフィス',
    addressLabel: '所在地：',
    address: '〒546-0002 大阪府大阪市東住吉区杭全1-17-17 3F',
    emailLabel: 'メール：',
    sendMessage: 'お問い合わせ内容の入力',
    name: 'お名前',
    email: 'メールアドレス',
    subject: '件名（任意）',
    yourMessage: 'お問い合わせ内容',
    send: '送信する'
  },
  products: {
    title1: '還元型コエンザイムQ10とは？',
    subtitle1: '還元型コエンザイムQ10で、毎日の活力とコンディションをサポート。',
    body1: '「コエンザイムQ10は体内にも存在し、エネルギー産生（ATP）に関わる成分として知られています。」',
    body2: '「還元型（ユビキノール）は、抗酸化作用をもつ形として知られています。」',
    body3: '体内で利用される形（還元型）に着目した成分です。',
    featuresTitle: '製品の特徴',
    feature1Title: '還元型コエンザイムQ10',
    feature1Text: '酸化型に比べ、還元型は体内で利用されやすい形として知られています。',
    feature2Title: 'プレミアム成分',
    feature2Text: '厳選した原料を使用',
    feature3Title: '科学的根拠による裏付け',
    feature3Text: '文献情報に基づき、成分特性を紹介',
    detailsTitle: '製品詳細',
    distributionTitle: '販売・購入',
    officialStore: '誠科医薬公式ストア',
    address: '住所：〒531-0073 大阪府大阪市東住吉区杭全1-17-17 3F',
    contact: 'お問い合わせ：',
    ingredients: '成分',
    ingredientsTitle: '成分',
    ingredientsText1: '還元型コエンザイムQ10',
    ingredientsText2: 'サフラワー油',
    ingredientsText3: 'グリセリン脂肪酸エステル',
    ingredientsText4: 'ミツロウ',
    specification: '仕様',
    specificationText1: '1粒あたり CoQ10 100mg 含有',
    specificationText2: '内容量：30粒',
    specificationText3: '',
    suggestedUse: '使用方法',
    suggestedUseText1: '健康維持のために',
    suggestedUseText2: '1日1〜2粒を目安に水などと一緒にお召し上がりください',
    suggestedUseText3: '',
    shelfLife: '賞味期限',
    shelfLifeText1: '製造日より24か月',
    shelfLifeText2: '',
    shelfLifeText3: '',
    targetUsersTitle: '対象ユーザー',
    targetUsersText1: '疲れを感じている方',
    targetUsersText2: '中高年の方',
    targetUsersText3: '心血管疾患のある方',
    targetUsersText4: '慢性疾患のある方',
    benefitsTitle: '利点',
    benefitsText1: '心臓の健康を増進',
    benefitsText2: '老化防止',
    benefitsText3: '日々の活力を向上',
    benefitsText4: '身体の必須物質合成能力を改善',
    packageTitle: 'パッケージと用量',
    packageText1: '30カプセル/ボトル',
    packageText2: 'ソフトカプセル',
    packageText3: '1日1カプセル'
  },
  platform: {
    title: 'エンドツーエンドの統合生産ソリューション',
    upstreamLabel: '上流:',
    upstreamValue: '原材料',
    upstream1: '登録戦略指導',
    upstream2: 'コンプライアンス・コンサルティング',
    upstream3: 'チャネル・マッチング',
    midstreamLabel: '中流:',
    midstreamValue: '製品の研究開発と生産',
    midstream1: '製品設計サポート',
    midstream2: '革新的な製剤開発',
    downstreamLabel: '下流:',
    downstreamValue: '販売とマーケティング',
    downstream1: '販売と市場開拓'
  },
  services: {
    rawMaterial: '原材料調達・供給',
    productCustomization: '処方設計・製造受託',
    importExport: '輸出入手続き・物流支援',
    learnMore: '詳細はこちら >'
  },
  flow: {
    title: '企画から納品までの一気通貫プロセス',
    titleMobile1: 'ドア・ツー・ドアのカスタマイズ',
    titleMobile2: '生産プロセス',
    manufactureCoordination: '製造調整',
    oa: '仕様確定',
    manufacturing: '製造',
    packaging: '包装・表示',
    shipping: '出荷',
    seikaPharma: '誠科医薬',
    tradeCompliance: '各国規制に対応した輸出入・導入支援',
    tradeComplianceMobile1: 'コンプライアンスを遵守した国際貿易',
    tradeComplianceMobile2: '（輸出入規制）',
    customer: 'お客様',
    exportCertificate: '輸出入関連書類（証明書・許認可）取得支援',
    specialPackaging: 'お客様指定先への個別梱包・配送',
    back: '前のページへ戻る'
  },
  business: {
    title: '医薬品の海外展開支援',
    titleMobile1: '医薬品',
    titleMobile2: '輸出入',
    marketResearch: '市場調査と分析',
    regulations: '規制対応・コンプライアンス',
    productRegistration: '申請・登録支援',
    logistics: '物流・サプライチェーン管理',
    description: '私たちは、医薬品の海外展開に必要な市場調査から規制対応、申請・登録、物流設計までを一貫して支援します。各国パートナーと連携し、確実でスピーディーな導入体制の構築をサポートします。',
    learnMorePartners: 'パートナー一覧'
  },
  popularize: {
    title: '製品プロモーション戦略',
    subtitle: '統合オムニチャネル小売モデルの構築',
    offlinePromotion: 'オフライン販売促進',
    offlineP1: '国内完全カバーのオフライン販売チーム',
    offlineP2: '多面的なオフライン販促活動',
    offlineP3: '体系的なオフライン販売トレーニングシステム',
    onlinePlatform: 'オンライン運営プラットフォーム',
    onlineP1: 'オンライン専門Eコマース運営チーム',
    onlineP2: 'ワンストップデジタルマーケティング体験',
    onlineP3: 'ニューメディアマルチプラットフォーム協力チャネル',
    offlineChannels: 'オフラインチャネル',
    retailPharmacies: '小売薬局',
    publicHospitals: '公立病院',
    medicalCosmetologies: '美容医療',
    beautySalon: '美容サロン',
    onlineChannels: 'オンラインチャネル',
    ecommerceChannels: 'Eコマースチャネル',
    livestreaming: 'ライブストリーミング運営チーム'
  },
  material: {
    title: 'ニーズに合わせた原材料調達・供給調整サービス',
    titleMobile1: 'カスタマイズされた原材料と',
    titleMobile2: '供給調整サービス',
    supplyServices: '原材料・中間体の調達／供給サービス',
    supplyDescription: '原材料・中間体の調達と、輸出入手続きをワンストップで支援します。',
    salesAgencyServices: '販売チャネル開拓支援',
    salesAgencyDescription: '原材料の販路開拓や取引先開拓を支援し、\n販売体制の構築をサポートします。',
    apiServices: '原薬（API）・中間体 供給サービス',
    apiDescription: '研究開発（R&D）から製造まで対応可能なパートナーと連携し、お客様の要件に応じた原薬（API）・中間体の調達／供給を支援します。'
  },
  expansion: {
    title: 'グローバル市場拡大',
    marketAnalysis: '市場分析と戦略',
    globalCompliance: 'グローバルコンプライアンスと登録',
    buildingSalesChannels: '販売チャネルの構築',
    elevatingBrand: 'ブランドプレゼンスの向上',
    buildingAlliances: '戦略的提携の構築',
    monitoringOptimizing: 'モニタリングと最適化'
  },
  coq10: {
    auth: {
      accessDenied: 'アクセス拒否',
      providePassword: '正しいアクセスパスワードを入力してください',
      enterPassword: 'アクセスパスワードを入力',
      confirm: '確認',
      incorrectPassword: 'パスワードが間違っています。もう一度お試しください！',
      verificationSuccess: '認証に成功しました！'
    },
    hero: {
      brandName: 'PHARMOPTIMA',
      productName: '還元型コエンザイムQ10カプセル',
      capacity: '100mg',
      subtitle: '優れた吸収性、最大の効果、活力を取り戻す！',
      reducedForm: '還元型',
      coq10: 'CoQ10'
    },
    info: {
      whatIsTitle: '還元型コエンザイムQ10とは？',
      whatIsText1: 'コエンザイムQ10（CoQ10）は体内で自然に生成される物質であり、細胞エネルギー（ATP）の生成に不可欠であり、強力な抗酸化物質でもあります。',
      whatIsText2: '還元型コエンザイムQ10は、体内のCoQ10の活性型（>95%）です（Wade et al., JAGS 55:1141, 2007）。エネルギー供給、抗酸化保護、フリーラジカルの除去を行い、心血管系および神経系に顕著な効果をもたらします。高い生体利用効率を持ち、直接吸収されます。加齢とともに体内のCoQ10レベルは低下し、還元型CoQ10レベルは著しく低下します。',
      advantagesTitle: '製品の利点',
      adv1Title: '還元型コエンザイムQ10',
      adv1Text: '変換不要、急速吸収、高い生体利用効率、酸化型の8倍の吸収率。',
      adv2Title: '高品質な成分',
      adv2Text: '日本最高品質の還元型コエンザイムQ10原料を使用し、優れた製品性能を実現。',
      adv3Title: '科学的根拠による裏付け',
      adv3Text: '7つの主要な科学論文がその有効性を支持しています。'
    },
    productInfo: {
      title: '製品情報',
      targetUsersTitle: '対象ユーザー',
      targetUsers1: '夜更かしや疲れやすい方',
      targetUsers2: '中高年の方',
      targetUsers3: '心血管疾患のある方',
      targetUsers4: '慢性疾患のある方',
      scopeTitle: '適用範囲',
      scope1: '心筋細胞を保護し、心臓の健康を増進',
      scope2: '老化防止',
      scope3: '日々の活力を向上',
      scope4: '身体の必須物質合成能力を改善',
      ingredientsTitle: '成分',
      ingredient1: '還元型コエンザイムQ10',
      ingredient2: 'ベニバナ油',
      ingredient3: 'グリセリン脂肪酸エステル',
      ingredient4: 'ミツロウ',
      specTitle: '仕様、剤形、使用方法',
      spec1: '30カプセル/ボトル',
      spec2: 'ソフトカプセル',
      spec3: '1日1粒',
      marketTitle: '販売国/地域および分類、販売チャネル',
      market1: '日本/栄養補助食品',
      market2: '越境EC'
    },
    purchase: {
      buyNow: '今すぐ購入',
      scanCode: 'QRコードをスキャンして購入',
      contactUs: 'お問い合わせ'
    }
  },
  registration: {
    title: '薬事申請と製品登録',
    titleMobile1: '薬事申請と製品',
    titleMobile2: '登録',
    roadMapTitle: '登録サービスロードマップ',
    marketEntryStrategy: '市場参入戦略',
    registrationServices: '中国における登録サービス',
    registrationServicesExplain: '医薬品、原薬、新食品原料、化粧品を含む',
    endToEndSupport: '一貫したサポート',
    proposalCreating: '提案書の作成',
    technicalSupport: '技術サポート',
    documentReview: '書類レビュー',
    documentDrafting: '書類作成',
    governmentCommunication: '政府機関とのコミュニケーション',
    processTracking: 'プロセスの追跡'
  },
  meta: {
    home: 'セイカファーマ',
    about: '会社概要 | セイカファーマ',
    technology: '技術紹介 | セイカファーマ',
    products: '製品紹介 | セイカファーマ',
    contacts: 'お問い合わせ | セイカファーマ',
    platform: 'プラットフォーム | セイカファーマ',
    services: 'サービス | セイカファーマ',
    popularize: 'プロモーション | セイカファーマ',
    expansion: '海外展開 | セイカファーマ',
    material: '原材料 | セイカファーマ',
    flow: '生産プロセス | セイカファーマ',
    business: '輸出入事業 | セイカファーマ',
    registration: '薬事申請・登録 | PHARM OPTIMA',
    coq10: '還元型CoQ10 | PHARMOPTIMA',
    oem: 'OEM/ODM（受託製造） | セイカファーマ',
    gmi: 'GMI リペアジェル | セイカファーマ'
  },
  oem: {
    header: '食品用口腔溶解フィルム受託製造サービス|製薬グレードの工程管理と品質管理',
    subheader: '試作・スケールアップ・量産まで一貫対応　OEM/ODMソリューション',
    bubble1: '水なし服用',
    bubble2: '瞬時溶解',
    bubble3: '1枚ごとの定量化',
    bubble4: '携帯に便利',
    productShowcase: '製品紹介',
    applicationAreas: '製品応用分野',
    appBubble1: '美容・栄養',
    appBubble2: '口内爽快・ケア',
    appBubble3: '免疫サポート・日常の栄養補給',
    appBubble4: 'エネルギー・集中力',
    appBubble5: '睡眠・リラックス',
    appBubble6: '基礎栄養補給',
    equipmentTitle: '主要設備およびクリーンルーム環境',
    caption1: 'コーティング・乾燥一体機\n均一なコーティングと高速乾燥・成型',
    caption2: '裁断・包装システム\n多様な規格に対応 + オンライン検査、自動排出',
    caption3: '生産現場環境\nGMP Dクラス清浄度基準',
    footer1: '規制認証対応',
    footer2: 'モジュール設計',
    footer3: '全工程のスマート管理',
    footer4: '高精度な設備管理',
    footer5: '製薬レベルの品質管理'
  },
  salacia: {
    title: '五層龍PLUS / Salacia Plus',
    intro: '五層龍PLUSは、サラシアエキスを主成分に配合した日本製の健康補助食品です。糖質の摂取が気になる方や、日々の健康管理を意識する方の食生活をサポートすることを目指しています。毎日のバランスの良い食事と健やかな生活習慣とあわせてお召し上がりいただくことをおすすめします。',
    aboutTitle: 'サラシアエキスについて',
    about1: '糖質の摂取が気になる方の健康維持をサポートする植物由来素材です。',
    about2: 'サラシア由来の成分「サラシノール」を含んでいます。',
    about3: '毎日の健康管理をサポートする素材として配合しています。',
    disclaimer: '本品は、健康維持を目的とした健康補助食品です。医薬品ではありません。また、疾病の診断、治療または予防を目的としたものではありません。',
    cautionTitle: 'ご注意',
    cautionLine1: '本品は、健康維持を目的とした健康補助食品です。医薬品ではありません。',
    cautionLine2: 'また、疾病の診断、治療または予防を目的としたものではありません。',
    featuresTitle: '製品特長',
    features: {
      item1: 'サラシノールを含むサラシアエキスを配合。',
      item2: '毎日の健康管理を意識する方に取り入れやすい設計。',
      item3: 'GMPおよびFSSC 22000に基づく品質管理体制のもとで製造。'
    },
    detailsTitle: '製品詳細',
    details: {
      ingredientsTitle: '主な配合原料',
      ingredientsText: 'サラシアエキス、バナバ粉末、米ぬか発酵物 など。',
      specUsageTitle: '規格・お召し上がり方',
      spec1: '剤形：タブレット',
      spec2: '内容量：1本120粒',
      suggestedUseTitle: 'お召し上がりの目安',
      suggested1: '1日4粒を目安に、水などとともにお召し上がりください。',
      suggested2: '毎日の健康管理に、食生活が気になるときに',
      shelfLifeTitle: '賞味期限',
      shelf1: '製造日より24か月'
    },
    distributionTitle: '販売・購入',
    officialStore: '誠科医薬公式ストア',
    addressLine: '住所：〒531-0073 大阪府大阪市東住吉区杭全1-17-17 3F',
    contactLabel: 'お問い合わせ：'
  }
}
